import { useContextSelector } from 'use-context-selector';
import { UserStateContext } from '../context/UserContext/UserContext';

export const useFilterValuesByReportId = (id: string) => {
  const filterValues = useContextSelector(UserStateContext, (v) => {
    const userLogin = v?.state.userLogin;
    if (userLogin) {
      return v?.state.filterValues[userLogin][id];
    }
    return [];
  });
  return filterValues;
};
